import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import TabPanel from 'components/Tabs/TabPanel';
import HeaderTabs, {tabsDictionary} from 'features/POSRegisters/POSTable/HeaderTabs';
import CloudServices from 'features/POSRegisters/POSTable/CloudServices';
import NetworkCircuit from 'features/POSRegisters/POSTable/NetworkCircuit';
import SwitchConnectivity from 'features/POSRegisters/POSTable/SwitchConnectivity';
import RedirectSwitchParams from 'features/POSRegisters/POSTable/SwitchConnectivity/interfaces/RedirectSwitchParams';
import Registers from 'features/POSRegisters/POSTable/Registers';
import TabsType from 'features/POSRegisters/interfaces/Tabs';
import POSState from 'features/POSRegisters/interfaces/POSState';

interface POSTableContainerProps {
  switchRedirectInfo: RedirectSwitchParams;
  state: POSState;
}

export default function POSTableContainer({switchRedirectInfo, state}: POSTableContainerProps) {
  const [selectedTab, setSelectedTab] = useState<TabsType>(tabsDictionary.REGISTERS);
  const {networkCircuits} = state;

  return (
    <Grid container>
      <HeaderTabs
        state={state}
        selectedTab={selectedTab}
        handleTabChange={tab => setSelectedTab(tab)}
      />
      <Grid item xs={12}>
        <TabPanel value={selectedTab} index={tabsDictionary.CLOUD_SERVICES}>
          <CloudServices />
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.NETWORK_CIRCUIT}>
          <NetworkCircuit list={networkCircuits} />
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.SWITCH_CONNECTIVITY}>
          <SwitchConnectivity switchRedirectInfo={switchRedirectInfo} />
        </TabPanel>
        <TabPanel value={selectedTab} index={tabsDictionary.REGISTERS}>
          <Registers state={state} />
        </TabPanel>
      </Grid>
    </Grid>
  );
}
